import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import ReactDOM from 'react-dom';
var isValidElement = React.isValidElement;
export { isValidElement };
export function replaceElement(element, replacement, props) {
  if (!isValidElement(element)) return replacement;
  return /*#__PURE__*/React.cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
}
export function cloneElement(element, props) {
  return replaceElement(element, element, props);
}
/**
 * React17类型的Class组件转成React18类型的组件(仅做type转换)
 * 因为转成React18的Class组件的写法没有试出来，暂时先转成FC组件
 */

export function normalizeComponent(component, isRef) {
  return isRef ? component : component;
}

var fullClone = _objectSpread({}, ReactDOM);

var mainVersion = Number((fullClone.version || '').split('.')[0]);
var shouldUseFlushSync = mainVersion >= 18 && 'flushSync' in fullClone;
export function flushSync(callback) {
  if (shouldUseFlushSync) {
    fullClone.flushSync(callback);
  } else {
    callback();
  }
}